$(function () { 
    var slick = $('.slick--carousel').slick({   
      arrows: false,
      dots: true,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
    });

  var slick2 = $('.slick--testimonials').slick({
    arrows: false,
    cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000,
     slidesToShow: 3,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  });

  $('.stamped-product-reviews-badge').click(function(){
    $("html, body").animate({ scrollTop: $('#stamped-main-widget').offset().top }, 1000);
  });

});